import { useAuth, ROLE_LABELS } from "../../lib/auth";
import { Link } from "react-router-dom";
import { Shield, Mail, User, Clock, ExternalLink, Settings } from "lucide-react";

export default function ProfilePage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="space-y-8 max-w-3xl" data-testid="profile-root">
      <div>
        <p className="text-overline text-aawta-pink mb-2 flex items-center gap-2"><User size={14} /> MY PROFILE</p>
        <h1 className="font-display text-4xl text-white">{user.name || "Account"}</h1>
        <p className="text-white/50 mt-2 text-sm">Your AAWTA Backoffice account details. Roles are managed by the Super Admin.</p>
      </div>

      <section className="border border-white/10 bg-aawta-charcoal/40 divide-y divide-white/5">
        <Row icon={Mail} label="Email" value={user.email} />
        <Row icon={User} label="Display Name" value={user.name || "—"} />
        <Row icon={Shield} label="Role" value={
          <span className="text-aawta-pink" data-testid="profile-role">{ROLE_LABELS[user.role] || "—"}</span>
        } />
        <Row icon={Clock} label="Last Login" value={user.last_login ? new Date(user.last_login).toLocaleString() : "—"} />
        <Row icon={Clock} label="Account Created" value={user.created_at ? new Date(user.created_at).toLocaleDateString() : "—"} />
      </section>

      <section>
        <p className="text-overline text-white/50 mb-3">QUICK ACTIONS</p>
        <div className="grid sm:grid-cols-2 gap-3">
          {user.role === "super_admin" && (
            <Link to="/admin/users" data-testid="profile-link-users" className="block border border-white/10 hover:border-aawta-pink p-4 transition-colors">
              <p className="text-white flex items-center gap-2"><Settings size={14} /> Manage Users</p>
              <p className="text-white/50 text-xs mt-1">Add new admins, change roles, deactivate accounts.</p>
            </Link>
          )}
          <a href="https://www.aawta.org" target="_blank" rel="noopener noreferrer" className="block border border-white/10 hover:border-aawta-pink p-4 transition-colors">
            <p className="text-white flex items-center gap-2"><ExternalLink size={14} /> Visit AAWTA.org</p>
            <p className="text-white/50 text-xs mt-1">Open the public association site in a new tab.</p>
          </a>
        </div>
      </section>
    </div>
  );
}

function Row({ icon: Icon, label, value }) {
  return (
    <div className="flex items-center gap-4 px-5 py-4">
      <Icon size={16} className="text-aawta-pink shrink-0" />
      <p className="text-overline text-white/50 w-40 shrink-0">{label}</p>
      <p className="text-sm text-white/90">{value}</p>
    </div>
  );
}
